import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { useUsersPage } from "../../context";

const PageSearchBar: FC = () => {
  const { searchData } = useUsersPage();

  return (
    <FlexCenter columnGap={"1rem"} marginBottom={"1rem"}>
      <SearchField placeholder="Search" {...searchData} />
    </FlexCenter>
  );
};

export default PageSearchBar;
